/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { difference } from '@utils/lodash';

export namespace Types {
  type AddressField =
    | 'line1'
    | 'line2'
    | 'city'
    | 'stateCode'
    | 'county'
    | 'countryCode'
    | 'provinceCode'
    | 'postalCode';

  export type USAddressField = AddressField &
    ('line1' | 'line2' | 'city' | 'stateCode' | 'postalCode' | 'county' | 'countryCode');

  export type CanadaAddressField = AddressField &
    ('line1' | 'line2' | 'city' | 'provinceCode' | 'postalCode' | 'countryCode');
}

const USFieldsRecord: Record<Types.USAddressField, string> = {
  line1: '',
  line2: '',
  city: '',
  stateCode: '',
  postalCode: '',
  county: '',
  countryCode: '',
};

const canadaFieldsRecord: Record<Types.CanadaAddressField, string> = {
  line1: '',
  line2: '',
  city: '',
  provinceCode: '',
  postalCode: '',
  countryCode: '',
};

export const US_FIELDS = Object.keys(USFieldsRecord);
export const CANADA_FIELDS = Object.keys(canadaFieldsRecord);
export const US_ONLY_FIELDS = difference(US_FIELDS, CANADA_FIELDS);
export const CANADA_ONLY_FIELDS = difference(CANADA_FIELDS, US_FIELDS);
